
import React from 'react';
import { X, LucideIcon } from 'lucide-react';

interface ExitButtonProps {
  onExit: () => void;
  label?: string;
  className?: string;
  icon?: LucideIcon;
}

export const ExitButton: React.FC<ExitButtonProps> = ({ onExit, label = 'EXIT', className = '', icon: Icon = X }) => {
  return (
    <button
      onClick={onExit}
      className={`fixed top-[120px] right-6 flex items-center gap-2 text-slate-400 hover:text-white z-[400] transition-all bg-slate-900/80 hover:bg-slate-700/80 border border-slate-700 hover:border-slate-500 px-5 py-2.5 rounded-full shadow-lg backdrop-blur-sm ${className}`}
    >
      <span className="text-xs font-black tracking-[0.2em] uppercase">{label}</span>
      <Icon size={16} />
    </button>
  );
};
